/* ==========================================================
   wwjf2026-quick-modal.js
   モーダル専用JS — どのページからでも共通で動作する
   依存: window.db, window.WWJF_CATALOG_PRODUCTS, window.wishlist
   ========================================================== */

(function () {

  // ----------------------------------------
  // 内部ユーティリティ
  // ----------------------------------------
  function getDb() {
  const baseDb = window.WWJF_DB || {};
  const extraDb = window.db || {};
  const mergedDb = {};

  const ids = new Set([
    ...Object.keys(baseDb),
    ...Object.keys(extraDb)
  ]);

  ids.forEach(function(id) {
    const baseItem = baseDb[id] || {};
    const extraItem = extraDb[id] || {};

    const mergedItem = Object.assign({}, baseItem);

    Object.keys(extraItem).forEach(function(key) {
      const value = extraItem[key];

      if (
        value !== undefined &&
        value !== null &&
        value !== ''
      ) {
        mergedItem[key] = value;
      }
    });

    mergedDb[id] = mergedItem;
  });

  return mergedDb;
}


  function getCatalog()  { return window.WWJF_CATALOG_PRODUCTS || []; }
  function getWishlist() { return window.wishlist || new Set(); }

  function showToast(msg) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    toast.innerText = msg;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 3000);
  }

  // ----------------------------------------
  // 価格フォーマット（¥なし・カンマあり）
  // ----------------------------------------
  function formatPrice(raw) {
    const num = String(raw).replace(/[^0-9]/g, '');
    return num ? Number(num).toLocaleString('ja-JP') : raw;
  }

  // ----------------------------------------
// モーダルを開く
// ----------------------------------------
window.openProductModal = function (id) {
  const db = getDb();
  const item = db[id];

  if (!item) return;

  window.currentModalId = id;

  // テキスト系
  const set = (elId, val) => {
    const el = document.getElementById(elId);
    if (el) el.innerText = val || '';
  };

  set('modalBrand', item.brand);
  set('modalTitle', item.title);
  set('modalReference', item.reference);

  // PRODUCT SPECS
  // 商品説明ではなく、商品メタフィールドのHTMLを表示
  const modalDesc = document.getElementById('modalDesc');

  if (modalDesc) {
    modalDesc.innerHTML = item.detailHtml || '';
  }

    // PRODUCT DESCRIPTION
  const descriptionSection =
    document.getElementById('modalDescriptionSection');

  const descriptionContent =
    document.getElementById('modalProductDescription');

  const descriptionMore =
    document.getElementById('modalProductDescriptionMore');

  const descriptionHtml =
  String(item.descriptionHtml || '').trim();


  if (
    descriptionSection &&
    descriptionContent &&
    descriptionMore
  ) {
    if (descriptionHtml) {
      descriptionSection.hidden = false;

      descriptionContent.innerHTML = descriptionHtml;
      descriptionContent.classList.remove('is-expanded');
      descriptionContent.classList.add('is-collapsed');

      descriptionMore.hidden = false;
      descriptionMore.innerText = 'READ MORE';

      descriptionMore.onclick = function() {
        const isExpanded =
          descriptionContent.classList.toggle('is-expanded');

        descriptionContent.classList.toggle(
          'is-collapsed',
          !isExpanded
        );

        descriptionMore.innerText =
          isExpanded ? 'READ LESS' : 'READ MORE';
      };

} else {
  descriptionSection.hidden = true;
  descriptionContent.innerHTML = '';
  descriptionMore.hidden = true;
}

  }


  // 価格
  const elPriceNum = document.getElementById('modalPriceNum');

  if (elPriceNum) {
    elPriceNum.innerText = formatPrice(item.price);
  }

  // 画像
  const elImg = document.getElementById('modalImg');

  if (elImg) {
    elImg.src = item.img || '';
  }

  // バッジ（NEW / 限定）
  const elBadges = document.getElementById('modalBadges');

  if (elBadges) {
    const p = getCatalog().find(x => x.id === id);
    let html = '';

    if (p && p.isNew) {
      html += '<span class="product-modal__badge product-modal__badge--new">NEW</span>';
    }

    if (p && p.limitedText) {
      html += `<span class="product-modal__badge product-modal__badge--limited">${p.limitedText}</span>`;
    }

    elBadges.innerHTML = html;
  }

  updateModalButtonState();

  // Online Storeに公開されていない商品の詳細ボタンを非表示
  const detailBtn = document.querySelector(
    '#quickModal [onclick*="goToDetailPage"]'
  );

  if (detailBtn) {
    detailBtn.hidden = !(item.isPublished === true && item.url);
  }

  // モーダル表示
  const modal = document.getElementById('quickModal');
  const card = document.getElementById('modalCard');

  if (modal && card) {
    modal.classList.add('is-open');
    void modal.offsetWidth;
    card.classList.add('is-open');
  }
};


  // ----------------------------------------
  // モーダルを閉じる
  // ----------------------------------------
  window.closeProductModal = function () {
    const card  = document.getElementById('modalCard');
    const modal = document.getElementById('quickModal');
    if (card)  card.classList.remove('is-open');
    setTimeout(() => {
      if (modal) modal.classList.remove('is-open');
      window.currentModalId = null;
    }, 500);
  };

  // ----------------------------------------
  // 詳細ページへ遷移
  // ----------------------------------------
  window.goToDetailPage = function () {
  if (!window.currentModalId) return;

  const item = getDb()[window.currentModalId];

  if (item && item.url) {
    window.open(item.url, '_blank');
  } else if (item && item.id) {
    window.open(`/products/${item.id}`, '_blank');
  } else {
    showToast('詳細ページが見つかりません');
  }
};

  // ----------------------------------------
  // ボタン状態の更新（いいね・詳細）
  // ----------------------------------------
  function updateModalButtonState() {
    const detailBtn = document.getElementById('modalDetailBtn');
    const detailTxt = document.getElementById('modalDetailText');
    const likeBtn   = document.getElementById('modalLikeIconBtn');
    if (!detailBtn || !detailTxt || !likeBtn) return;

    detailBtn.classList.remove('is-editorial');

    if (['blog', 'lounge'].includes(window.currentModalId)) {
      detailBtn.classList.add('is-editorial');
      likeBtn.style.display = 'none';
      detailTxt.innerText = 'READ MORE';
      // ↓ editorial の場合は onclick を上書きせざるを得ないので残す
      detailBtn.onclick = () => { showToast('別ページへ遷移します'); window.closeProductModal(); };
      return;
    }

    likeBtn.style.display = 'flex';
    detailTxt.innerText = '商品詳細ページへ/公式HP';

    detailBtn.onclick = function () {
      window.goToDetailPage();
    };
    const wl = getWishlist();
    likeBtn.classList.toggle('is-liked', wl.has(window.currentModalId));
  }

  // グローバルに公開（toggleLike から呼ばれる）
  window.updateModalButtonState = updateModalButtonState;

  // ----------------------------------------
  // モーダル内いいねボタン
  // ----------------------------------------
  window.toggleModalLike = function (e) {
    const id = window.currentModalId;
    if (id && !['blog', 'lounge'].includes(id)) {
      if (typeof window.toggleLike === 'function') window.toggleLike(e, id);
    }
  };

  /* 通常商品用モーダルの固定名 */
window.openWWJFDefaultProductModal = window.openProductModal;

})();
